import { Map, List } from 'immutable';
import { combineReducers } from 'redux';
import {
  FETCH_PRODUCTS,
  FETCH_PRODUCTS_SUCCESS,
  FETCH_PRODUCTS_FAIL,
  FETCH_GLOBAL_SEARCH_SUCCESS,
  FETCH_QUICK_SEARCH_SUCCESS,
  FETCH_PRODUCT,
  FETCH_PRODUCT_SUCCESS,
  FETCH_PRODUCT_FAIL,
  FETCH_CAMPAIGN_PRODUCTS,
  FETCH_CAMPAIGN_PRODUCTS_SUCCESS,
  FETCH_CAMPAIGN_PRODUCTS_FAIL
} from '../actions/actionTypes';

const initialState = Map();

const transformSearchData = (payload = {}) => {
  const productHits = payload.getIn(['products', 'hits'], []);

  if (productHits.length === 0) {
    return List();
  }
  const filteredProductHits = productHits.filter(product => product.get('item') && product.get('relevance'));
  return filteredProductHits.map(product => product.get('item').merge({ relevance: product.get('relevance'), allVariantsHaveSameRelevance: product.get('allVariantsHaveSameRelevance') }));
};

const formatData = (arrayData, key = 'id') =>
  arrayData
    .toMap()
    .filter(item => item.get('url') && item.get('id')) // filter out products that do not have a URL, should be done in backend, but can't wait for them to fix it...
    .mapEntries(entry => {
      const newEntry = entry;
      newEntry[0] = entry[1].get(key);
      return newEntry;
    });

function data(state = initialState, { type, payload }) {
  switch (type) {
    case FETCH_PRODUCT_SUCCESS:
      return state.mergeDeep(payload);

    case FETCH_PRODUCTS_SUCCESS:
      return state.mergeDeep(payload);

    case FETCH_CAMPAIGN_PRODUCTS_SUCCESS:
      return state.mergeDeep(payload);

    case FETCH_GLOBAL_SEARCH_SUCCESS:
      return state.mergeDeep(formatData(transformSearchData(payload)));

    case FETCH_QUICK_SEARCH_SUCCESS:
      return state.mergeDeep(formatData(transformSearchData(payload)));

    default:
      return state;
  }
}

function request(state = initialState, { type, error, meta }) {
  switch (type) {
    case FETCH_CAMPAIGN_PRODUCTS:
    case FETCH_PRODUCT:
    case FETCH_PRODUCTS: {
      const next = { [meta.url]: { status: 'LOADING' } };
      return state.merge(next);
    }

    case FETCH_CAMPAIGN_PRODUCTS_SUCCESS:
    case FETCH_PRODUCT_SUCCESS:
    case FETCH_PRODUCTS_SUCCESS: {
      const next = { [meta.url]: { status: 'SUCCESS', statusCode: 200 } };
      return state.merge(next);
    }
    case FETCH_CAMPAIGN_PRODUCTS_FAIL:
    case FETCH_PRODUCT_FAIL:
    case FETCH_PRODUCTS_FAIL: {
      const next = { [meta.url]: { status: 'ERROR', statusCode: error.response.status } };
      return state.merge(next);
    }

    default:
      return state;
  }
}

export const products = combineReducers({ data, request });



// WEBPACK FOOTER //
// ./src/reducers/products.js